import { Component, Input } from '@angular/core';
import { ContentService } from 'src/app/services/content.service';
import { PlayerService } from 'src/app/services/player.service';
import { StatesService } from 'src/app/services/states.service';
import { TimerService } from 'src/app/services/timer.service';

@Component({
  selector: 'app-timer-component',
  templateUrl: './timer-component.component.html',
  styleUrls: ['./timer-component.component.scss'],
})
export class TimerComponentComponent {
  @Input() component: any;
  timerInterval: any;
  startTimerSub: any;
  stopTimerSub: any;
  setTimerSub: any;
  timerActive: boolean = false;

  constructor(
    public statesService: StatesService,
    public contentService: ContentService,
    private playerService: PlayerService,
    private timerService: TimerService
  ) {}
  ngOnInit(): void {
    if (this.component.data.autoStart) {
      this.onStartTimer();
    }
    this.startTimerSub = this.timerService.startTimer.subscribe(
      (componentId: any) => {
        if (componentId && componentId == this.component.id) {
          // yes, start it
          this.onStartTimer();
          this.timerService.startTimer.next(null);
        }
      }
    );

    this.stopTimerSub = this.timerService.stopTimer.subscribe(
      (componentId: any) => {
        if (componentId && componentId == this.component.id) {
          // yes, start it
          this.onStopTimer();
        }
      }
    );

    this.setTimerSub = this.timerService.setTimer.subscribe(
      (controlData: any) => {
        if (controlData && controlData?.componentId == this.component.id) {
          // yes, start it
          this.component.data.count = controlData.count;
        }
      }
    );
  }

  onMouseDown() {
    this.statesService.onMouseDown(this.component);
  }
  onMouseUp() {
    this.statesService.onMouseUp(this.component);
  }

  onMouseEnter() {
    this.statesService.onMouseEnter(this.component);
  }
  onMouseLeave() {
    this.statesService.onMouseLeave(this.component);
  }
  onStartTimer() {
    if (!this.timerActive) {
      this.timerActive = true;
      this.timerInterval = setInterval(() => {
        if (
          this.component.data.direction == 'd' &&
          this.component.data.count > this.component.data.min
        ) {
          this.component.data.count--;
        } else if (
          this.component.data.direction == 'u' &&
          this.component.data.count < this.component.data.max
        ) {
          this.component.data.count++;
        }

        // do the action
        this.component.data.actions.forEach((action: any) => {
          action.events.forEach((_event: any) => {
            if (_event.id == 'onTimerAt') {
              // get the value
              if (+this.component.data.count == +_event.vars[0].value) {
                this.playerService.doAction(
                  this.component,
                  action,
                  null,
                  'timerAt',
                  null
                );
              }
            }
            if (_event.id == 'onTimerTick') {
                this.playerService.doAction(
                  this.component,
                  action,
                  null,
                  'timerTick',
                  null
                );
            }
          });
        });

        if (
          this.component.data.count == this.component.data.min ||
          this.component.data.count == this.component.data.max
        ) {
          clearInterval(this.timerInterval);
        }
      }, 1000);
    }
  }

  onStopTimer() {
    if (this.timerActive) {
      clearInterval(this.timerInterval);
      this.timerActive = false;
    }
  }
  ngOnDestroy() {
   
      clearInterval(this.timerInterval);
      this.setTimerSub.unsubscribe();
      this.startTimerSub.unsubscribe();
      this.stopTimerSub.unsubscribe();
      this.timerActive = false;
  }
}
